import api from "./../api";
import UtilsUrl from "../../utils/UtilsUrl";

const getEmployeeSalary = async (idUser, selectedMonth, selectedYear) => {
  const response = await api.get(
    UtilsUrl.rhURL() +
      `/ficheDePaie/employeeSalary/${idUser}?month=${selectedMonth}&year=${selectedYear}`
  );

  return response.data;
};
const getMonthsAndYears = (idUser) => {
  return api.get(UtilsUrl.rhURL() + "/Attendance/months-and-years/" + idUser);
};
const getEmployeeFiltred = async (idUser, filter) => {
  const response = await api.get(
    UtilsUrl.rhURL() + `/ficheDePaie/userFilter/${idUser}?filter=${filter}`
  );

  return response.data;
};
const getInfoPerEmployee = async (selectedMonth, selectedYear, idUser) => {
  const response = await api.get(
    UtilsUrl.rhURL() +
      `/ficheDePaie/getSalaryPerEmployee/${idUser}?month=${selectedMonth}&year=${selectedYear}`
  );

  return response.data;
};

const getSalaireEmp = async (dateDeb, dateFin, idUser, idUserCreation) => {
  const response = await api.get(
    UtilsUrl.rhURL() +
      `/ficheDePaie/salaire_personnel/${dateDeb}/${dateFin}/${idUser}/${idUserCreation}`
  );

  return response.data;
};
const getSalaryPerEmployeeAndUpdateHisPrime = async (
  idUser,
  selectedMonth,
  selectedYear,
  userPrimeModel
) => {
  const response = await api.post(
    UtilsUrl.rhURL() +
      `/ficheDePaie/getSalaryPerEmployeeAndUpdateHisPrime/${idUser}/${selectedMonth}/${selectedYear}`,
    userPrimeModel
  );

  return response.data;
};

const getInfoPerEmployeeWithSelection = async (
  yearSelection,
  monthSelection,
  selectedUsersIds
) => {
  const response = await api.get(
    UtilsUrl.rhURL() +
      `/ficheDePaie/getInfoPerEmployeeWithSelection/${monthSelection}/${yearSelection}`,
    selectedUsersIds
  );

  return response.data;
};
const getSalaryForEmployee = async (idUser) => {
  const response = await api.get(
    UtilsUrl.rhURL() + `/getEmployeeSalary/${idUser}`
  );
  const data = response.data;
  return data;
};
const generateFicheDePaie = (idUser, idFicheDePaie) => {
  return api.get(
    UtilsUrl.rhURL() +
      `/uploadFileRH/generateFichedePaie/${idUser}/${idFicheDePaie}`
  );
};

const getEmployeeSalaryWitoutPresenceAndUpdateHisPrime = async (
  heureSupp,
  idUser,
  idUserCreation,
  dateDeb,
  dateFin,
  userPrimeModel
) => {
  const response = await api.post(
    UtilsUrl.rhURL() +
      `/ficheDePaie/getEmployeeSalaryWitoutPresenceAndUpdateHisPrime/${dateDeb}/${dateFin}/${idUser}/${idUserCreation}/${heureSupp}`,
    userPrimeModel
  );

  return response.data;
};

const getInfoAndUpdatePrimeForManyEmployees = async (
  heureSupp,
  dateDeb,
  dateFin,
  selectedUsersIds,
  selectedPrimes
) => {
  const response = await api.get(
    UtilsUrl.rhURL() +
      `/ficheDePaie/updatePrimeForManyEmployees/${dateDeb}/${dateFin}/${heureSupp}?userIds=` +
      encodeURIComponent(selectedUsersIds),
    selectedPrimes
  );

  return response.data;
};
export {
  generateFicheDePaie,
  getEmployeeSalary,
  getMonthsAndYears,
  getEmployeeFiltred,
  getInfoPerEmployee,
  getSalaryPerEmployeeAndUpdateHisPrime,
  getInfoPerEmployeeWithSelection,
  getSalaireEmp,
  getEmployeeSalaryWitoutPresenceAndUpdateHisPrime,
  getSalaryForEmployee,
  getInfoAndUpdatePrimeForManyEmployees,
};
